import styled from "@emotion/styled";
import { CrossButton } from "./CrossButton";

export const AbsCrossButton = styled(CrossButton)`
  position: absolute;
  top: 20px;
  right: 20px;
`;
